/** Visible tab: poll unread status at most every 15s. */
export const MESSAGING_POLL_INTERVAL_MS = 15_000;

/** Hidden tab: slow poll to detect new messages without saturating the API. */
export const MESSAGING_POLL_INTERVAL_HIDDEN_MS = 60_000;

/** Initial backoff delay after the first 429/503 on a poll request. */
export const MESSAGING_POLL_BACKOFF_BASE_MS = 30_000;

/** Cap for exponential backoff between poll retries. */
export const MESSAGING_POLL_BACKOFF_MAX_MS = 180_000;

/** Multiplier applied to the previous backoff delay on consecutive 429/503. */
export const MESSAGING_POLL_BACKOFF_FACTOR = 2;

/** Random jitter added to each computed backoff delay. */
export const MESSAGING_POLL_BACKOFF_JITTER_MS = 1_000;

export const MESSAGING_UNREAD_POLL_PATH = "/mensajes/unread-poll";

/**
 * @param {number} previousDelayMs Last applied backoff delay (0 before first failure).
 * @returns {number}
 */
export function nextMessagingPollBackoffMs(previousDelayMs = 0) {
  const scaled =
    previousDelayMs > 0
      ? Math.min(
          MESSAGING_POLL_BACKOFF_MAX_MS,
          previousDelayMs * MESSAGING_POLL_BACKOFF_FACTOR,
        )
      : MESSAGING_POLL_BACKOFF_BASE_MS;
  const jitter = Math.floor(Math.random() * MESSAGING_POLL_BACKOFF_JITTER_MS);
  return scaled + jitter;
}
